"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useGetChatHeight = function () {
    var _a = (0, react_1.useState)(500), height = _a[0], setHeight = _a[1];
    function calculateHeight() {
        var _a, _b, _c;
        var windowH = window.innerHeight;
        var distance = 73 + Math.max(((_b = (_a = document.getElementById('chatWindow')) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) === null || _b === void 0 ? void 0 : _b.top) || 100, 100);
        var messageH = (_c = document.getElementById('messageBox')) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect().height;
        if (!distance || !messageH) {
            setHeight(500);
            return;
        }
        setHeight(Math.min(windowH - distance - messageH, 500));
    }
    (0, react_1.useEffect)(function () {
        calculateHeight();
        window.addEventListener('resize', calculateHeight);
        return function () {
            window.removeEventListener('resize', calculateHeight);
        };
    }, []);
    return height;
};
exports.default = useGetChatHeight;
